export enum ScrollDirection {
  UP = 'up',
  DOWN = 'down'
}

export enum HorizontalScrollType {
  DEFAULT = 'default',
  NEGATIVE = 'negative',
  REVERSE = 'reverse'
}
